import { CARD_TYPES } from 'cards/constants/CardTypes';
import GuestAddressingIcon from '../../assets/images/invitations/guest-addressing.svg';

// for general Cards:
export const QUANTITIES = [20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150, 160, 170, 180, 190, 200, 210, 220, 230, 240, 250, 260, 270, 280, 290, 300, 310, 320, 330, 340, 350, 360, 370, 380, 390, 400];
export const QUANTITY_OPTIONS = QUANTITIES.map(quantity => ({ label: quantity.toString(), value: quantity }));
export const DEFAULT_PAPER_TYPE_VALUE = 'smooth'; // use smooth as default to prevent bug with foil cards that dont have eggshell paper-type as an option
export const DEFAULT_SHAPE_VALUE = 'square';

export const ALL_FILTER_COLORS = [
  'BLACK',
  'BLUE',
  'BROWN',
  'GREEN',
  'GREY',
  'ORANGE',
  'PINK',
  'PURPLE',
  'RED',
  'WHITE',
  'YELLOW'
];

export const TEXT_ALIGNMENT_OPTIONS = ['LEFT', 'CENTER', 'RIGHT'];
export const BACK_PRINTING_PRICE = 35;

export const CARD_TYPE = {
  [CARD_TYPES.invitation]: {
    type: CARD_TYPES.invitation,
    urlSlug: 'invitations',
    label: 'Invitations',
    hasFoil: true,
    hasLetterpress: true,
    hasMotifs: true,
    hasMultipleOrientations: true,
    hasThirdPartyDesigns: true,
    hasCustomPhoto: true,
    hasNoCustomPhoto: true,
    isLead: true,
    showPdpFreeAddressingModule: false,
    freeAddressingText: null,
    freeAddressingImage: null,
    showPdpCtdBanner: true,
    showPdpCovidBanner: false,
    showReviewStepCtdBanner: true,
  },
  [CARD_TYPES.std]: {
    type: CARD_TYPES.std,
    urlSlug: 'save-the-date',
    label: 'Save The Dates',
    hasFoil: true,
    hasLetterpress: true,
    hasMotifs: true,
    hasMultipleOrientations: true,
    hasThirdPartyDesigns: true,
    hasCustomPhoto: true,
    hasNoCustomPhoto: true,
    isLead: true,
    showPdpFreeAddressingModule: false,
    freeAddressingText: null,
    freeAddressingImage: null,
    showPdpCtdBanner: true,
    showPdpCovidBanner: false,
    showReviewStepCtdBanner: true,
  },
  [CARD_TYPES.ctd]: {
    type: CARD_TYPES.ctd,
    urlSlug: 'change-the-date',
    label: 'Change The Dates',
    hasFoil: false,
    hasLetterpress: true,
    hasMotifs: false,
    hasMultipleOrientations: true,
    hasThirdPartyDesigns: false,
    hasCustomPhoto: true,
    hasNoCustomPhoto: true,
    isLead: true,
    showPdpFreeAddressingModule: false,
    freeAddressingText: null,
    freeAddressingImage: null,
    showPdpCtdBanner: false,
    showPdpCovidBanner: true,
    showReviewStepCtdBanner: false,
  },
  [CARD_TYPES.thankyou]: {
    type: CARD_TYPES.thankyou,
    urlSlug: 'thank-you-cards',
    label: 'Thank You Cards',
    hasFoil: true,
    hasLetterpress: true,
    hasMotifs: true,
    hasMultipleOrientations: false,
    hasThirdPartyDesigns: true,
    hasCustomPhoto: true,
    hasNoCustomPhoto: true,
    isLead: true,
    showPdpFreeAddressingModule: true,
    freeAddressingText: 'Enjoy FREE Guest Addressing & Envelopes',
    freeAddressingImage: GuestAddressingIcon,
    showPdpCtdBanner: false,
    showPdpCovidBanner: false,
    showReviewStepCtdBanner: false,
  },
  [CARD_TYPES.menu]: {
    type: CARD_TYPES.menu,
    urlSlug: 'menus',
    label: 'Menus',
    hasFoil: true,
    hasLetterpress: true,
    hasMotifs: true,
    hasMultipleOrientations: false,
    hasThirdPartyDesigns: true,
    hasCustomPhoto: true,
    hasNoCustomPhoto: false,
    isLead: true,
    showPdpFreeAddressingModule: null,
    freeAddressingText: null,
    freeAddressingImage: null,
    showPdpCtdBanner: false,
    showPdpCovidBanner: false,
    showReviewStepCtdBanner: false,
  },
  [CARD_TYPES.program]: {
    type: CARD_TYPES.program,
    urlSlug: 'programs',
    label: 'Programs',
    hasFoil: true,
    hasLetterpress: true,
    hasMotifs: true,
    hasMultipleOrientations: false,
    hasThirdPartyDesigns: true,
    hasCustomPhoto: true,
    hasNoCustomPhoto: false,
    isLead: true,
    showPdpFreeAddressingModule: null,
    freeAddressingText: null,
    freeAddressingImage: null,
    showPdpCtdBanner: false,
    showPdpCovidBanner: false,
    showReviewStepCtdBanner: false,
  },
  [CARD_TYPES.placecards]: {
    type: CARD_TYPES.placecards,
    urlSlug: 'place-cards',
    label: 'Place Cards',
    hasFoil: false,
    hasLetterpress: false,
    hasMotifs: true,
    hasMultipleOrientations: false,
    hasThirdPartyDesigns: true,
    hasCustomPhoto: false,
    hasNoCustomPhoto: true,
    isLead: true,
    showPdpFreeAddressingModule: true,
    freeAddressingText: 'Enjoy FREE printing on Place Cards!',
    freeAddressingImage: GuestAddressingIcon,
    showPdpCtdBanner: false,
    showPdpCovidBanner: false,
    showReviewStepCtdBanner: false,
  },
  DETAILS: {
    type: 'DETAILS',
    urlSlug: 'enclosures',
    label: 'Enclosures',
    hasFoil: true,
    hasLetterpress: true,
    hasMotifs: true,
    hasMultipleOrientations: true,
    hasThirdPartyDesigns: true,
    hasCustomPhoto: true,
    hasNoCustomPhoto: false,
    isLead: true,
    showPdpFreeAddressingModule: null,
    freeAddressingText: null,
    freeAddressingImage: null,
    showPdpCtdBanner: false,
    showPdpCovidBanner: false,
    showReviewStepCtdBanner: false,
  },
  [CARD_TYPES.enclosure]: {
    type: CARD_TYPES.enclosure,
    urlSlug: 'enclosures',
    label: 'Enclosures',
    hasFoil: true,
    hasLetterpress: true,
    hasMotifs: true,
    hasMultipleOrientations: true,
    hasThirdPartyDesigns: true,
    hasCustomPhoto: true,
    hasNoCustomPhoto: false,
    isLead: true,
    showPdpFreeAddressingModule: null,
    freeAddressingText: null,
    freeAddressingImage: null,
    showPdpCtdBanner: false,
    showPdpCovidBanner: false,
    showReviewStepCtdBanner: false,
  },
  [CARD_TYPES.rsvp]: {
    type: CARD_TYPES.rsvp,
    urlSlug: null, // secondary card type, no slug.
    label: 'RSVP',
    hasFoil: true,
    hasLetterpress: true,
    hasMotifs: null,
    hasMultipleOrientations: true,
    hasThirdPartyDesigns: null,
    hasCustomPhoto: true,
    hasNoCustomPhoto: true,
    isLead: false,
    showPdpFreeAddressingModule: null,
    freeAddressingText: null,
    freeAddressingImage: null,
    showPdpCtdBanner: null,
    showPdpCovidBanner: null,
    showReviewStepCtdBanner: null,
  },
  ENVELOPE: {
    type: 'ENVELOPE',
    urlSlug: null, // secondary card type, no slug.
    label: 'Envelope',
    hasFoil: null, // Not used for now
    hasLetterpress: false,
    hasMotifs: null,
    hasMultipleOrientations: null,
    hasThirdPartyDesigns: null,
    hasCustomPhoto: null,
    hasNoCustomPhoto: null,
    isLead: false,
    showPdpFreeAddressingModule: null,
    freeAddressingText: null,
    freeAddressingImage: null,
    showPdpCtdBanner: null,
    showPdpCovidBanner: null,
    showReviewStepCtdBanner: null,
    hiddenPlpFilters: null, // secondary card type no PLP
  },
  [CARD_TYPES.holiday]: {
    type: CARD_TYPES.holiday,
    urlSlug: 'holiday-cards',
    label: 'Holiday Cards',
    hasFoil: false,
    hasLetterpress: true,
    hasMotifs: false,
    hasMultipleOrientations: false,
    hasThirdPartyDesigns: false,
    hasCustomPhoto: true,
    hasNoCustomPhoto: true,
    isLead: true,
    showPdpFreeAddressingModule: true,
    freeAddressingText: 'Enjoy FREE Guest Addressing & Envelopes',
    freeAddressingImage: GuestAddressingIcon,
    showPdpCtdBanner: false,
    showPdpCovidBanner: false,
    showReviewStepCtdBanner: false,
  }
};

export const PAGES = ['FRONT', 'INSIDE', 'BACK', 'RSVP', 'RSVP ENVELOPE', 'ENVELOPE'];
export const PAGE_URLS = {
  FRONT: 'detailFront',
  INSIDE: 'detailInside',
  BACK: 'detailBack',
  RSVP: 'rsvp',
  'RSVP ENVELOPE': 'rsvpEnvelope',
  ENVELOPE: 'envelope'
};

// for PLP:
export const ALL_COLORS = [
  'BLACK',
  'BLUE',
  'BROWN',
  'GREEN',
  'GREY',
  'ORANGE',
  'PINK',
  'PURPLE',
  'RED',
  'WHITE',
  'YELLOW',
  'BEIGE'
];

export const BASE_URL = '/wedding-planning';



// WEBPACK FOOTER //
// ./src/cards/constants/Cards.js